// The city's published description rarely says anything useful about
// the actual proposal — until we ingest DMAP content in a future
// iteration, point readers there directly.
export function DescriptionSection({
  dmapUrls,
}: {
  dmapUrls: string[];
}) {
  const primary = dmapUrls[0];
  if (!primary) return null;

  return (
    <section className="ph-detail-panel" aria-label="The proposal">
      <h2 className="ph-detail-panel-l">
        <span>The proposal</span>
      </h2>
      <div className="ph-detail-prose">
        <p className="ph-detail-prose-body">
          The city&rsquo;s published agenda description rarely captures
          what&rsquo;s actually being proposed. For the full picture —
          site plans, current zoning, proposed zoning, and surrounding
          context — see the property record on{" "}
          <a
            href={primary}
            target="_blank"
            rel="noreferrer"
            className="ph-detail-prose-link"
          >
            DMAP
          </a>
          {dmapUrls.length > 1 && (
            <>
              {" "}(
              {dmapUrls.slice(1).map((url, i) => (
                <span key={url}>
                  {i > 0 && ", "}
                  <a
                    href={url}
                    target="_blank"
                    rel="noreferrer"
                    className="ph-detail-prose-link"
                  >
                    site {i + 2}
                  </a>
                </span>
              ))}
              )
            </>
          )}
          , the City of Calgary&rsquo;s development map.
        </p>
      </div>
    </section>
  );
}
